import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    icon: {
      color: theme.palette.primary.main,
      fontSize: 100,
    },
    title: {
      color: '#4D4F5C',
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: 0,
    },
    subtitle: {
      color: '#2C2C2E',
      fontSize: theme.typography.fontSize,
      fontWeight: 500,
      marginTop: '20px',
    },
    content: {
      color: '#4D4F5C',
      fontSize: theme.typography.fontSize,
    },
    paragraph: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.fontSize,
      marginTop: theme.spacing(3),
    },
    checkField: {
      marginTop: 8,
      marginBottom: 8,
      width: 'auto',

      '& .MuiButtonBase-root': {
        padding: '0 10px 0 0',
      },
      '& .MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    dateField: {
      marginBottom: 12,
      width: '100%',
    },
    reasonSelect: {
      marginTop: 0,
    },
    reasonText: {
      '& .MuiFormLabel-root': {
        paddingRight: '15px',
        lineHeight: '1.2em',
      },
    },
  };
});

export { useStyles };
